export const NONE = "none";
export const MAIN_MENU = "Rugged Brain";
export const SETTINGS = "Settings";
export const TIME_PICKER = "Time";
export const FREEFORM = "DAILY - FIX ME";
export const MULTIDAY = "MULTIDAY - FIX ME";
export const LOGIN = "Login";
export const SIGN_UP = "Sign Up";
export const MANAGE_HABITS = "Manage Habits";
export const CREATE_HABIT = "Create Habit";
export const VIEW_HABIT = "View Habit";
export const EDIT_HABIT = "Edit Habit";
export const SINGLESITE = "Single Site";

export type HabitDestination =
  | "DAILY - FIX ME"
  | "MULTIDAY - FIX ME"
  | "Single Site";
